export default __webpack_public_path__ + "static/media/github.3880ceac.svg";